import LoadingSpinner from './LoadingSpinner'

const LoadingBlocker = ({ size = '' }) => {
  return (
    <div className={`loading-blocker ${size}`}>
      <LoadingSpinner size={size} />
    </div>
  )
}

export default LoadingBlocker
